import OrganizationCard from './OrganizationCard';
import Layout from './Layout';
import { Row, Col } from 'reactstrap';
import MonthlyTransactionCard from './MonthlyTransactionCard';
import MonthlyTransactionByAction from './MonthlyTransactionByActionCard';
import CustomerExportButton from './CustomerExportButton';

const OrganizationManagement = () => {

    return (
        <Layout>
            <Row fluid className="vh-100 w-100 p-2 m-0 d-flex flex-column h-100 flex-grow-1">
                <Col md={9}><OrganizationCard /></Col>
                <Col md={3}>
                    <MonthlyTransactionCard />
                    <MonthlyTransactionByAction />
                    <CustomerExportButton />
                </Col>
            </Row>
        </Layout>
    );
};

export default OrganizationManagement;